export enum Permission {
  CREATE_SANDBOX = 'CREATE_SANDBOX',

  DEPLOY_CONFIG_INSTANCE = 'DEPLOY_CONFIG_INSTANCE',
  UPDATE_CONFIG_INSTANCE = 'UPDATE_CONFIG_INSTANCE',
  TERMINATE_CONFIG_INSTANCE = 'TERMINATE_CONFIG_INSTANCE',

  TERMINATE_PTL_INSTANCE = 'TERMINATE_PTL_INSTANCE',
  DEPLOY_PTL_INSTANCE = 'DEPLOY_PTL_INSTANCE',
  UPDATE_PTL_INSTANCE = 'UPDATE_PTL_INSTANCE',
  UPDATE_SECRETS = 'UPDATE_SECRETS',

  EDIT_PTL_WORKFLOW = 'EDIT_PTL_WORKFLOW',
  DEFINE_PTL_WORKFLOW = 'DEFINE_PTL_WORKFLOW',

  CONFIGURE_SERVICE = 'CONFIGURE_SERVICE',
  PUBLISH_CONFIG_PACK = 'PUBLISH_CONFIG_PACK',

  UPLOAD_CRVT = 'UPLOAD_CRVT',

  CREATE_SERVICE_DEFINITION = 'CREATE_SERVICE_DEFINITION',
  DELETE_SERVICE_DEFINITION = 'DELETE_SERVICE_DEFINITION',
  UPDATE_SERVICE_DEFINITION = 'UPDATE_SERVICE_DEFINITION',

  VIEW_ENTERPRISE = 'VIEW_ENTERPRISE',
  VIEW_ENTERPRISE_PROSPECT = 'VIEW_ENTERPRISE_PROSPECT',
  VIEW_ENTERPRISE_SERVICE = 'VIEW_ENTERPRISE_SERVICE',
  UPGRADE_ENTERPRISE = 'UPGRADE_ENTERPRISE',

  VIEW_SETTINGS = 'VIEW_SETTINGS',
  DOWNLOAD_IAC = 'DOWNLOAD_IAC',

  SERVICES_SECTION= 'SERVICES_SECTION',
  RETRY = 'RETRY',
  NO_SERVICES = 'NO_SERVICES',
  SERVICE_DEF_MENU = 'INSTANCE_MENU',
  APPLY_RELEASE_PACKAGE = 'APPLY_RELEASE_PACKAGE',
  APPLY_RELEASE_PACKAGE_HOTFIX = 'APPLY_RELEASE_PACKAGE_HOTFIX',
  APPLY_RELEASE_PACKAGE_TILL_TEST = 'APPLY_RELEASE_PACKAGE_TILL_TEST',
  CREATE_EXTEND_SERVICE = 'CREATE_EXTEND_SERVICE',
}

export enum Permissions {
  SOLUTION_CREATE = '/solution/create',
  SOLUTION_READ = '/solution/read',
  SOLUTION_UPDATE = '/solution/update',
  SOLUTION_DELETE = '/solution/delete',
  TENANT_READ = '/tenant/read',
  TENANT_CREATE = '/tenant/create',
  TENANT_UPDATE = '/tenant/update',
  BLUEPRINT_READ = '/blueprint/read',
  BLUEPRINT_CREATE = '/blueprint/create',
  BLUEPRINT_UPDATE = '/blueprint/update',
  CONFIGURATION_READ = '/configuration/read',
  INSTANCE_DR = '/instance/dr',
  TENANT_ONBOARDING = '/tenant/onboarding',
  INSTANCE_UPDATE = '/instance/update',
  INSTANCE_READ = '/instance/read',
  INSTANCE_CONFIG = '/instance/config',
  INSTANCE_SFTP_CONFIG = '/instance/sftp/config',
  INSTANCE_REDEPLOY = '/instance/redeploy',
  INSTANCE_EXTEND = '/instance/extend',
  INSTANCE_START = '/instance/start',
  INSTANCE_STOP = '/instance/stop',
  INSTANCE_TEST = '/instance/test',
  INSTANCE_DELETE = '/instance/delete',
  BLUEPRINT_DELETE = '/blueprint/delete',
  INSTANCE_CREATE  = '/instance/create',
  INSTANCE_AGENT_MANAGE = '/instance/agent/manage'
}

export enum Datazone {
  PII = 'pii',
  NONPII = 'nonpii',
  LIVE = 'prod'
}

export enum Types {
  TSI = 'tsi',
  TSS = 'tss',
  DEV = 'dev',
  PTL = 'ptl',
  LIVE = 'live',
  OTHERS = 'others'
}

export enum IDs {
  ID = 'id'
}

export enum Attributes {
  DATAZONE = 'datazone',
  TYPE = 'type',
  ID = 'id'
}
